<div class="osp-slider__container">
  <div class="tooltip-area-container">
    <div class="tooltip-anchor" [ngStyle]="{ 'left.%': $tooltipShiftPercent() }">
      <div class="slider-tooltip">
        {{ $tooltipText() }}
      </div>
    </div>
  </div>

  <p-slider
    [formControl]="control()"
    [min]="min"
    [max]="max"
    [step]="step"
    [range]="range"
    [orientation]="orientation"
    [tabindex]="tabindex"
    [styleClass]="cssClass"
  >
  </p-slider>
  <div class="osp-slider__min-max-labels">
    <p class="text-xs text-500">{{ min + $labelsSuffix() }}</p>
    <p class="text-xs text-500">{{ max + $labelsSuffix() }}</p>
  </div>
</div>
